__turbopack_context__.v({
  "content": "view-module__4wtDkW__content",
  "fade-in": "view-module__4wtDkW__fade-in",
  "header": "view-module__4wtDkW__header",
  "modal": "view-module__4wtDkW__modal",
  "overlay": "view-module__4wtDkW__overlay",
  "slide-down": "view-module__4wtDkW__slide-down",
  "title": "view-module__4wtDkW__title",
});
